/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class UserLimitationField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props
    const options = [{ key: 1, text: 'Limit', value: true }, { key: 2, text: 'Unlimit', value: false }]

    return (
      <Form.Select
        fluid
        label="Limitation per user"
        options={options}
        placeholder="Limit or Unlimit"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/UserLimitationField.js